import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Buffer } from "buffer";
import { useDispatch } from "react-redux";
import { setLoggedInUser } from "../redux/slices/userSlice";
import "./Login.css";
import { toast } from "react-toastify";
import ForgotPasswordDialog from "./ForgotPasswordDialogBox";
import { Typography } from "@mui/material";
import { Box, Tabs, Tab, Paper } from "@mui/material";
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { useTheme, useMediaQuery } from "@mui/material";



import {
  makeStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import {
  Container,
  TextField,
  Button,
  InputLabel,
  FormControlLabel,
  Checkbox
} from "@material-ui/core";
import theme from "../theme";
import elhiLockupWhite from "../logos/elhi-lockup-white.png";
import "./CommonDashboard.css";


const Login = ({
  classes,
  email,
  password,
  setEmail,
  setPassword,
  handleSubmit,
  handleSetLoggedInUser,
  decodedUser,
  setDecodedUser,
  staySignedIn,
  setStaySignedIn,
  firstTimeLogin
}) => {
  const [login, setLogin] = useState(false);
  const [selectedTab, setSelectedTab] = useState(0);
  const [showPassword, setShowPassword] = useState(false);
  const [clientId, setClientId] = useState("")
  const [token, setToken] = useState(() => localStorage.getItem("token"));
  const handleChange = (_, newValue) => {
    setSelectedTab(newValue)
    setEmail("");
    setPassword("")
    setShowPassword(false)
    setClientId("")
    if (decodedUser?.id) {
      setDecodedUser({})
    }
  };

  const dispatch = useDispatch();
  const [showConfirmation, setShowConfirmation] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const handleConfirmForgotPassword = async (e) => {
    e.preventDefault();
    try {
      const requestBody = {
        email,
      };
      const api = localStorage.getItem("api");
      await axios.put(api + `/user/forgetpassword`, requestBody);

      toast.success("New password has been sent to your email!!", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    } catch (error) {
      console.error(error);
      toast.error("Failed to send password reset request.", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
    setShowConfirmation(false);
  };

  const handleForgotPassword = (e) => {
    e.preventDefault();
    setShowConfirmation(true);
  };
  const handleCancelChange = () => {
    setShowConfirmation(false);
  };

  const handleSendRequest = () => {
    try {
      throw new Error("client id not found!")
      const api = localStorage.getItem("api");


      axios
        .post(`${api}/requestAccess`, {
          email,
          clientId,
        })
        .then((response) => {
          const data = response.data;
        })
        .catch((err) => {
          console.error(err);
          toast.error(err?.response?.data || err?.message || "Request failed. Please check your credentials", {
            position: toast.POSITION.BOTTOM_RIGHT,
          });
        });
    } catch (error) {
      console.log("this is errror", error)
      toast.error(error?.message || error || "internal server error!", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }


  }


  const size = "0.77vw";



  return (
    <ThemeProvider theme={theme}>



      <Box
        sx={{
          height: "100vh",
          display: "flex",
          flexDirection: { xs: "column-reverse", md: "row" },
          overflow: "hidden",
          flexWrap: "wrap-reverse",
        }}
      >

        <Box
          sx={{
            height: { xs: "75%", md: "100%" },
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            width: {
              xs: "100%",
              md: "35.75vw",
              ld: "35.25vw",
            },
            maxWidth: { xs: 'unset', md: '645px' },
            background: "rgb(255,255,255)",
            pl: { xs: "10%", md: "7.35vw" },
            pr: { xs: "10%", md: "7.35vw" },
            pt: { xs: "1.5%", md: "8.9vh" },
            pb: { xs: "7.5%", md: "5%" },
            position: "relative",
            zIndex:200
          }}
        >
          <Box
            sx={{
              width: "100%",
              display: {
                xs: "none",
                md: "block",
              },
            }}
          >
            <img
              alt="Elhi Landscape Manager"
              src="https://storage.googleapis.com/content_ai_bucket_elhitech/content/d5663d2c-2f7e-40a0-b219-aee4dd2b9613-02c26c3a6208f366a2973bbef697bcda33f6de96%20(1)%20(1).png"
              className={` desktop-elhi-logo`}
              style={{
                height: "auto",
                display: "block",
                marginLeft: 0,
                marginBottom:"16px"
              }}
            />
          </Box>

          <Box className="auth-tabs-wrap">
            <Paper elevation={0} className="auth-tabs-paper">
              <Tabs
                value={selectedTab}
                onChange={handleChange}
                variant="standard"
                className="auth-tabs"
              >
                <Tab label="Sign In" />
                <Tab label="Request Access" />
              </Tabs>
            </Paper>
          </Box>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginTop: isMobile ? "20px" : "2.9vh",
            }}
          >
            <Typography
              variant="h5"
              sx={{
                color: "rgb(25,67,62)",
                textAlign: "start",
                fontWeight: "bold",
                fontSize: { xs: "1.5rem", md: "2.9vh" },
                marginLeft: { xs: 0, md: "0.2vw" },
              }}
            >
              {decodedUser?.id
                ? "Welcome Back."
                : selectedTab == 0
                  ? "Welcome To ELM."
                  : "Request Access."}
            </Typography>

 <Typography
                variant="body1"
                sx={{
                  color: "primary.main",
                  ml: { xs: 0, md: "0.2vw" },
                  textAlign: "start",
                  fontFamily: "Open Sans, sans-serif",
                  fontSize: { xs: "11px", md: "0.76vw" },
                  whiteSpace: "nowrap",
                  overflow: "visible",
                  textOverflow: "clip",
                  width: "max-content",
                  maxWidth: "none",
                  display: "block",
                }}
                className="manage-console-line"
              >
                One console to manage all your Elhi Products
              </Typography>
            {/* <FluidLabel /> */}
          </div>

          <form
            onSubmit={(e) => {
              e.preventDefault();
              if (selectedTab === 0) {
                handleSubmit(e);
              } else {
                handleSendRequest(e);
              }
            }}
            style={{
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
              paddingBottom: "2px",
            }}
          >
            <Box
              sx={{
                pt: { xs: "26px", md: "3.1vh" },
                pl: { xs: 0, md: "0.2vw" },
                pr: { xs: 0, md: "0.6vw" },
                display: "flex",
                flexDirection: "column",
                gap: { xs: 0, md: "1vh" },
              }}
            >
              {!(decodedUser?.id && token) && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    marginBottom: "10px",
                  }}
                >
                  <InputLabel
                    style={{
                      color: "rgb(25,67,62)",
                      textAlign: "start",
                      marginBottom: "3px",
                      fontWeight: "bold",
                      fontSize: isMobile ? "13px" : "0.76vw",
                      fontFamily: "Open Sans, sans-serif",
                    }}
                  >
                    Work Email
                  </InputLabel>

                  <TextField
                    variant="outlined"
                    type="email"
                    size="small"
                    placeholder="user@elhi.tech"
                    required
                    fullWidth
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    InputProps={{
                      style: {
                        borderRadius: "8px",
                        background: "rgb(230, 233, 236)",
                      },
                    }}
                    inputProps={{
                      style: {
                        height: isMobile ? "1.65em" : "1.9vh",
                      },
                    }}
                  />
                </div>
              )}

              {!(decodedUser?.id && token) &&
                (selectedTab == 0 ? (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      marginBottom: "10px",
                    }}
                  >
                    <InputLabel
                      style={{
                        color: "rgb(25,67,62)",
                        textAlign: "start",
                        marginBottom: "3px",
                        fontWeight: "bold",
                        fontSize: isMobile ? "13px" : "0.76vw",
                        fontFamily: "Open Sans, sans-serif",
                      }}
                    >
                      Password
                    </InputLabel>

                    <TextField
                      variant="outlined"
                      size="small"
                      type={showPassword ? "text" : "password"}
                      required
                      placeholder="********"
                      fullWidth
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      InputProps={{
                        style: {
                          borderRadius: "8px",
                          background: "rgb(230, 233, 236)",
                        },
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() => setShowPassword(!showPassword)}
                              edge="end"
                            >
                              {showPassword ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      inputProps={{
                        style: {
                          height: isMobile ? "1.65em" : "1.9vh",
                        },
                      }}
                    />
                  </div>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      marginBottom: "10px",
                    }}
                  >
                    <InputLabel
                      style={{
                        color: "rgb(25,67,62)",
                        textAlign: "start",
                        marginBottom: "3px",
                        fontWeight: "bold",
                        fontSize: isMobile ? "13px" : "0.76vw",
                        fontFamily: "Open Sans, sans-serif",
                      }}
                    >
                      Client ID
                    </InputLabel>

                    <TextField
                      variant="outlined"
                      size="small"
                      type="text"
                      required
                      placeholder="C000001"
                      fullWidth
                      value={clientId}
                      onChange={(e) => setClientId(e.target.value)}
                      InputProps={{
                        style: {
                          borderRadius: "8px",
                          background: "rgb(230, 233, 236)",
                        },
                      }}
                      inputProps={{
                        style: {
                          height: isMobile ? "1.65em" : "1.9vh",
                        },
                      }}
                    />
                  </div>
                ))}

              {(decodedUser?.id && token) && (
                <Box
                  sx={{
                    width: "100%",
                    border: "2px solid rgb(25,67,52)",
                    borderRadius: "14px",
                    minHeight: "56px",
                    px: 2,
                    py: 1.5,
                    boxSizing: "border-box",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    cursor: "pointer",
                    background: "rgb(230, 233, 236)",
                    transition: "0.2s",
                    "&:hover": {
                      background: "rgb(230, 233, 236,0.8)",
                    },
                  }}
                  onClick={handleSetLoggedInUser}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      overflow: "hidden",
                    }}
                  >
                    <Typography
                      sx={{
                        color: "rgb(25,67,52)",
                        fontSize: "14px",
                        fontWeight: 600,
                        lineHeight: 1.2,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        textAlign: "start",
                      }}
                    >
                      {decodedUser?.username ||
                        decodedUser?.email?.split?.("@")?.[0] ||
                        "User"}
                    </Typography>

                    <Typography
                      sx={{
                        color: "rgb(25,67,52)",
                        fontSize: "12px",
                        opacity: 0.75,
                        mt: 0.5,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {decodedUser?.email || ""}
                    </Typography>
                  </Box>

                  <ArrowRightAltIcon
                    sx={{
                      color: "rgb(25,67,52)",
                      fontSize: "30px",
                      flexShrink: 0,
                      ml: 1,
                    }}
                  />
                </Box>
              )}

              {selectedTab == 0 && !(decodedUser?.id && token) && (
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Typography
                    onClick={handleForgotPassword}
                    sx={{
                      color: "#19433E",
                      fontSize: "12px",
                      cursor: "pointer",
                      display: "inline-block",
                      textAlign: "right",
                      fontWeight: "bold",
                      fontFamily: "Open Sans, sans-serif",
                    }}
                  >
                    Forgot password?
                  </Typography>

                  <FormControlLabel
                    style={{
                      marginLeft: 0,
                      width: "fit-content",
                      display: "inline-flex",
                      marginBottom: isMobile ? "4px" : 0,
                    }}
                    control={
                      <Checkbox
                        size="small"
                        style={{
                          padding: "4px",
                          color: "#19433E",
                        }}
                        value={staySignedIn}
                        onChange={(e) => setStaySignedIn(e.target.checked)}
                      />
                    }
                    label={
                      <Typography
                        style={{
                          fontSize: "12px",
                          lineHeight: 1,
                          color: "#19433E",
                        }}
                      >
                        Stay signed in
                      </Typography>
                    }
                  />
                </Box>
              )}

              {!(decodedUser?.id && token) &&
                (selectedTab == 0 ? (
                  <Button
                    style={{
                      textTransform: "none",
                      borderRadius: "8px",
                      height: isMobile ? "3.6em" : "2.22vw",
                      fontSize: isMobile ? "calc(3.6em * 0.32)" : "calc(2.4vw * 0.36)",
                      minHeight: 0,
                      padding: 0,
                      maxHeight: "38px",

                    }}
                    variant="contained"
                    color="primary"
                    type="submit"
                    fullWidth
                    className="submit-btn"
                  >
                    Sign In <ArrowRightAltIcon />
                  </Button>
                ) : (
                  <Button
                    style={{
                      textTransform: "none",
                      borderRadius: "8px",
                      height: isMobile ? "3.6em" : "2.22vw",
                      maxHeight: "38px",
                      fontSize: isMobile ? "calc(3.6em * 0.32)" : "calc(2.4vw * 0.36)",
                      minHeight: 0,
                      padding: 0,

                    }}
                    variant="contained"
                    color="primary"
                    type="submit"
                    fullWidth
                    className="submit-btn"
                  >
                    
                    Send Request <ArrowRightAltIcon />
                  </Button>
                ))}

              <Typography
                sx={{
                  color: "#19433E",
                  fontSize: "12px",
                  cursor: "pointer",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginTop: { xs: "15px", md: "10px" },
                  flexWrap: "wrap",
                  textAlign: "center",
                }}
                className="request-access-text"
              >
                {decodedUser?.id
                  ? `Not ${decodedUser?.username || decodedUser?.email?.split?.("@")?.[0] || "User"}?`
                  : selectedTab == 0
                    ? "Don't have access?"
                    : "Already have access?"}
                <Typography
                  onClick={() => {
                    if (decodedUser?.id) {
                      setDecodedUser({});
                      setSelectedTab(0);
                    } else {
                      setEmail("");
                      setPassword("");
                      setClientId("");
                      if (selectedTab) {
                        setSelectedTab(0);
                      } else {
                        setSelectedTab(1);
                      }
                    }
                  }}
                  sx={{
                    color: "#19433E",
                    fontSize: "12px",
                    cursor: "pointer",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginLeft: "2px",
                    fontWeight: "bold",
                    fontFamily: "Open Sans, sans-serif",
                  }}
                  className="request-access-text"
                >
                  {decodedUser?.id
                    ? " Sign in with a different user"
                    : selectedTab == 0
                      ? "Request it here"
                      : "Sign in here"}{" "}
                  <ArrowRightAltIcon />
                </Typography>
              </Typography>
            </Box>
          </form>

          <Box
            sx={{
              position: "fixed",
              bottom: 0,
              left: 0,
              right: 0,
              zIndex: 9999,

              display: { xs: "flex", md: "none" },
              justifyContent: "center",
              alignItems: "center",

              width: "100vw",
              paddingBottom: "env(safe-area-inset-bottom)",
              py: "8px",

              backgroundColor: "transparent",
              pointerEvents: "none",
            }}
          >
            <Typography
              sx={{
                color: "rgb(20,38,40)",
                fontSize: { xs: "7.5px", sm: "7.5px" },
                lineHeight: 1.15,
                fontWeight: 100,
                letterSpacing: "-0.5px",
                fontFamily: "'Open Sans', sans-serif",
                textAlign: "center",
                px: 1,
                fontWeight: 400,
              }}
            >
              {`v1.0.1 • Copyright ${new Date().getFullYear()} • Powered by ElhiTech • support@elhi.tech`}
            </Typography>
          </Box>

          <Box
            sx={{
              position: "absolute",
              bottom: "2%",
              left: 0,
              right: 0,
              display: { xs: "none", md: "flex" },
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography
              sx={{
                color: "rgb(20,38,40)",
                fontSize: { xs: "7.5px", sm: "0.67vw" },
                lineHeight: 1.15,
                fontWeight: 400,
                letterSpacing: "-0.5px",
                fontFamily: "'Open Sans', sans-serif",
                textAlign: "center",
                fontWeight: 400
              }}

              className="desktop-copyright"
            >
              {`v1.0.1 • Copyright ${new Date().getFullYear()} • Powered by ElhiTech • support@elhi.tech`}
            </Typography>
          </Box>

          {showConfirmation && (
            <ForgotPasswordDialog
              open={showConfirmation}
              onClose={handleCancelChange}
              onConfirm={handleConfirmForgotPassword}
            />
          )}
        </Box>
        <Box
          sx={{
            flex: 1,
            height: {
              xs: "25%",
              md: "100%"
            },
            position: "relative",
            overflow: "hidden"

          }}
        >
          <LoginRightSide />
        </Box>
      </Box>
    </ThemeProvider >
  );
};


export function LoginRightSide() {

  const randomNumber = React.useMemo(() => {
    return Math.floor(Math.random() * (1780 - 312 + 1)) + 312;
  }, []);


  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        position: "relative",

        backgroundImage:
          `url("https://storage.googleapis.com/content_ai_bucket_elhitech/content/739e74b992bc37c434ed96351ee7bd3fdfb38ecb%20(1).png")`,


        backgroundSize: "cover",
        backgroundPosition: "right center",
        backgroundRepeat: "no-repeat",
      }}
    >




      <Box
        component="img"
        src="https://storage.googleapis.com/content_ai_bucket_elhitech/content/25e56e28-c4d5-46d8-ad55-32478273cb4d-0666c234ff245c8357d18f63e0ff0ee7dd81bebe.png"
        alt=""
        sx={{
          position: { xs: "absolute", md: "fixed" },
          pointerEvents: "none",

          top: { xs: 0, md: "-28.91vh" },
          left: { xs: "10%", md: "4.34vw" },
          transform: { xs: "translateX(-50%)", md: "unset" },

          width: { xs: "120%", md: "93.2vw" },
          height: { xs: "auto", md: "81.11vh" },

          zIndex: { xs: 10, md: 103 },

          filter: { xs: "brightness(0.65) contrast(1.3)", md: "unset" },
          opacity: { xs: 1, md: 0.59 },
        }}
      />


      <Box
        component="img"
        src="https://storage.googleapis.com/content_ai_bucket_elhitech/content/25e56e28-c4d5-46d8-ad55-32478273cb4d-0666c234ff245c8357d18f63e0ff0ee7dd81bebe.png"
        alt=""
        sx={{
          position: { xs: "absolute", md: "fixed" },
          pointerEvents: "none",

          top: { xs: 0, md: "-27.66vh" },
          left: { xs: "10%", md: "4.34vw" },
          transform: { xs: "translateX(-50%)", md: "unset" },

          width: { xs: "120%", md: "104.45vw" },
          height: { xs: "auto", md: "90.86vh" },

          zIndex: { xs: 10, md: 103 },

          filter: { xs: "brightness(0.65) contrast(1.3)", md: "unset" },
          opacity: { xs: 1, md: 0.59 },
        }}
      />




      <Box
        component="img"
        src="https://storage.googleapis.com/content_ai_bucket_elhitech/content/9886ffbc-445b-42f9-a554-66c3a0025583-e09758a09e7ce683934c789d5bf0329cbde5aa64%20(1).png"
        alt=""
        sx={{
          position: { xs: "absolute", md: "fixed" },

          top: { xs: 0, md: "20.41vh" },
          left: { xs: 0, md: "41.95vw" },

          width: { xs: "100%", md: "92.82vw" },
          height: { xs: "100%", md: "80.75vh" },

          objectFit: "cover",
          zIndex: 104,
          pointerEvents: "none",

          filter: {
            xs: "brightness(0.04) contrast(1.3)",
            md: "unset",
          },

          transform: {
            xs: "rotate(90deg) scale(1.5)",
            md: "unset",
          },

          opacity: { xs: 1, md: 0.89 },
        }}
      />


      <Box
        sx={{
          position: "fixed",
          display: { xs: "none", md: "flex" },

          width: "62.95vw",
          height: "100vh",

          top: "-34.19vh",
          left: "52.48vw",

          transform: "rotate(0deg)",

          opacity: 0.28,

          backgroundColor: "rgba(20, 38, 40, 1)",



          pointerEvents: "none",
        }}
      />

      <Box
        sx={{
          position: "absolute",
          display: { xs: "none", md: "flex" },

          width: "100%",
          height: "100vh",

          top: 0,
          left: 0,


          opacity: 0.66,

          backgroundColor: "rgba(20, 38, 40, 1)",



          pointerEvents: "none",
        }}
      />
      <Box
        component="img"
        src="https://storage.googleapis.com/content_ai_bucket_elhitech/content/greenrectangle.png"
        alt=""
        sx={{
          position: "absolute",
          display: { xs: 'block', md: "none" },
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: 100,
          opacity: {
            xs: 0.9,
            md: 0.4,
          },
        }}
      />


      <Box
        sx={{
          position: "absolute",
          inset: 0,
          zIndex: 100,
          pointerEvents: "none",
        }}
      >
        {/* Mobile logo */}
        <Box
          component="img"
          src={elhiLockupWhite}
          alt="ElhiTech"
          sx={{
            position: "absolute",
            top: "3vh",
            left: {
              xs: "9vw",
              sm: '9vw',
            },
            width: "38%",
            maxWidth: "190px",
            /* The band is only 25vh tall on mobile, so cap the logo by height
               too — a width-only rule outgrows the band on wide/short screens. */
            maxHeight: "7.5vh",
            height: "auto",
            objectFit: "contain",
            objectPosition: "left top",
            display: { xs: "block", md: "none" },
          }}
        />

        {/* Quote/text block */}
        <Box
          sx={{
            position: "absolute",
            top: { xs: "unset", md: "47px" },
            bottom: { xs: "3.5vh", md: "unset" },
            left: { xs: "9vw", md: "50px" },
            maxWidth: { xs: "75%", md: "445px" },
            display: { xs: "flex", md: "none" },
            alignItems: "flex-start",
            gap: "33px",
            textAlign: "start",
            fontFamily: "'Open Sans', sans-serif",
            zIndex: 106
          }}
        >
          <Typography
            sx={{
              color: "#fff",
              fontSize: { xs: "73px", md: "73px" },
              lineHeight: 0.7,
              fontWeight: 200,
              opacity: 0.95,
              fontFamily: "Oleo Script",
              display: { xs: "none", md: "block" },
              pt: "17px",

            }}
          >
            &ldquo;
          </Typography>

          <Typography
            sx={{
              color: "#fff",
              /* Sub-360px screens wrapped this to 3 lines, which pushed the
                 block up into the logo. Unchanged from 385px upwards. */
              fontSize: { xs: "clamp(16px, 5.2vw, 20px)", md: "36px" },
              lineHeight: 1.15,
              fontWeight: 100,
              letterSpacing: "-0.5px",
              mt: "-6px",
              fontFamily: "'Open Sans', sans-serif",
              position: "relative",
            }}
          >
            Transform all your touchpoints with one{" "}
            <Box
              component="span"
              sx={{
                fontWeight: 700,
                fontStyle: "italic",
                display: "inline",
              }}
            >
              tru
            </Box>{" "}
            ecosystem.
          </Typography>
        </Box>
      </Box>

      <Box
        sx={{
          position: "absolute",
          top: "3vh",
          right: "3vh",
          width: "254px",
          height: "35px",
          background: "rgba(20, 38, 40, 1)",
          opacity: 0.72,
          borderRadius: "10px",
          display: { xs: "none", md: "flex" },
          alignItems: "center",
          px: 1.5,
          gap: 1.5,
          backdropFilter: "blur(4px)",
          zIndex: 110,


        }}
      >
        {/* Glowing Green Dot */}
        <Box
          sx={{
            width: "6px",
            height: "6px",
            borderRadius: "50%",
            backgroundColor: "#22c55e",
            boxShadow: "0 0 8px #22c55e",
            animation: "pulse 3s infinite",
            flexShrink: 0,

            "@keyframes pulse": {
              "0%": {
                transform: "scale(1)",
                opacity: 1,
              },
              "50%": {
                transform: "scale(1.4)",
                opacity: 0.6,
              },
              "100%": {
                transform: "scale(1)",
                opacity: 1,
              },
            },
          }}
        />

        <Typography
          sx={{
            color: "white",
            fontSize: "12px",
            fontWeight: 500,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {randomNumber} CMS Actions in Last Minute, Live
        </Typography>
      </Box>


      <Box
        sx={{
          width: "100%",
          height: "100%",
          padding: "10%",
          paddingTop: "8%",
          paddingBottom: "12%",
          display: { xs: "none", md: "block" }

        }
        }
      >

        <StatusDashboardLayout />
      </Box>
    </Box >
  )
}


export const AiRejectedCard = () => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "calc(var(--kiosk-scale) * 1.22)",
        p: "calc(var(--kiosk-scale) * 1)",
        paddingTop: "calc(var(--kiosk-scale) * 0.75)",
        paddingBottom: "calc(var(--kiosk-scale) * 0.75)",
        borderRadius: "calc(var(--kiosk-scale) * 1)",
        background: "#FFFFFF",
        boxShadow: "0px calc(var(--kiosk-scale) * 0.5) calc(var(--kiosk-scale) * 2.4) rgba(0, 0, 0, 0.08)",
        width: "max-content",
        height: "calc(var(--kiosk-scale) * 8)",
        animation: "floating 7s ease-in-out infinite",

        "@keyframes floating": {
          "0%": {
            transform: "translateY(0px)",
          },
          "50%": {
            transform: "translateY(-8px)",
          },
          "100%": {
            transform: "translateY(0px)",
          },
        },
      }}
    >
      {/* Icon Graphic */}
      <Box
        sx={{
          width: "calc(var(--kiosk-scale) * 6)",
          height: "calc(var(--kiosk-scale) * 5.5)",
          borderRadius: "calc(var(--kiosk-scale) * 0.9)",
          background: "#B7D8D4",
          position: "relative",
          overflow: "hidden",
          flexShrink: 0,
          scale: 1.1
        }}
      >
        <Box
          sx={{
            width: "calc(var(--kiosk-scale) * 1.22)",
            height: "calc(var(--kiosk-scale) * 1.22)",
            borderRadius: "50%",
            background: "#FFFFFF",
            position: "absolute",
            top: "20%",
            left: "20%",
          }}
        />
        <Box
          sx={{
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            height: "60%",
            background: "#123F3B",
            clipPath: "polygon(0% 100%, 0% 70%, 35% 30%, 65% 65%, 80% 50%, 100% 80%, 100% 100%)",
          }}
        />
      </Box>

      {/* Content */}
      <Box sx={{ display: "flex", flexDirection: "column", gap: "calc(var(--kiosk-scale) * 0.43)" }}>
        <Box
          sx={{
            background: "#1A3E39",
            color: "#FFFFFF",
            px: "calc(var(--kiosk-scale) * 1.22)",
            py: "calc(var(--kiosk-scale) * 0.5)",
            borderRadius: "calc(var(--kiosk-scale) * 0.6)",
            width: "fit-content",
          }}
        >
          <Typography
            sx={{
              fontSize: "calc(var(--kiosk-scale) * 0.92)",
              fontWeight: 700,
              letterSpacing: "0.05em",
              lineHeight: 1
            }}
          >
            AI REJECTED
          </Typography>
        </Box>
        <Box sx={{ display: "flex", flexDirection: "column", gap: "calc(var(--kiosk-scale) * 0.3)" }}>
          {["Violent Content Detected", "No Matching Resolution"].map((text) => (
            <Box key={text} sx={{ display: "flex", alignItems: "center", gap: "calc(var(--kiosk-scale) * 0.5)" }}>
              <CloseIcon sx={{ color: "#E06D6D", fontSize: "calc(var(--kiosk-scale) * 1.22)" }} /> {/* Scaled icon */}
              <Typography sx={{ color: "#222", fontSize: "calc(var(--kiosk-scale) * 0.9)", fontWeight: 500, lineHeight: 1 }}> {/* Scaled text */}
                {text}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export const SyncDoneCard = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "calc(var(--kiosk-scale) * 0.645)",
        p: "calc(var(--kiosk-scale) * 1.075)",
        borderRadius: "calc(var(--kiosk-scale) * 1.075)",
        paddingTop: "calc(var(--kiosk-scale) * 1.1)",
        paddingBottom: "calc(var(--kiosk-scale) * 1.1);",
        background: "#FFFFFF",
        boxShadow: "0px calc(var(--kiosk-scale) * 0.344) calc(var(--kiosk-scale) * 1.72) rgba(0, 0, 0, 0.08)",
        width: "calc(var(--kiosk-scale) * 19.7)",
        animation: "floating 4s ease-in-out infinite",

        "@keyframes floating": {
          "0%": {
            transform: "translateY(0px)",
          },
          "50%": {
            transform: "translateY(-8px)",
          },
          "100%": {
            transform: "translateY(0px)",
          },
        },
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: "calc(var(--kiosk-scale) * 0.645)" }}>
        <Box
          sx={{
            background: "#1A3E39",
            color: "#FFFFFF",
            px: "calc(var(--kiosk-scale) * 0.86)",
            py: "calc(var(--kiosk-scale) * 0.5)",
            borderRadius: "calc(var(--kiosk-scale) * 0.6)",
          }}
        >
          <Typography sx={{ fontSize: "calc(var(--kiosk-scale) * 0.92)", fontWeight: 700, lineHeight: 1, whiteSpace: "nowrap" }}>
            SYNC DONE
          </Typography>
        </Box>
        <Box>
          <Typography sx={{ fontWeight: 600, color: "#111", fontSize: "calc(var(--kiosk-scale) * 0.9)", lineHeight: 1.1, textAlign: "start" }}>
            Sync Job #335115
          </Typography>
          <Typography sx={{ color: "#777", fontSize: "calc(var(--kiosk-scale) * 0.5)", wordBreak: "break-all" }}>
            3f27cf28-322e-477c-bd92-739121b3c459
          </Typography>
        </Box>
      </Box>

      <Typography sx={{ fontSize: "calc(var(--kiosk-scale) * 0.9)", color: "#222", textAlign: "start", fontWeight: 400 }}>
        <strong>Type</strong> Envision Sync <strong>Frequency</strong> 24 Hours
      </Typography>

      <Box sx={{ display: "flex", flexDirection: "column", gap: "calc(var(--kiosk-scale) * 0.258)" }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: "calc(var(--kiosk-scale) * 0.344)" }}>
          <CheckIcon sx={{ color: "#52A97F", fontSize: "calc(var(--kiosk-scale) * 1.22)" }} />
          <Typography sx={{ fontSize: "calc(var(--kiosk-scale) * 0.9)", color: "#222", fontWeight: 500 }}>
            22 Events Imported
          </Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: "calc(var(--kiosk-scale) * 0.344)" }}>
          <CloseIcon sx={{ color: "#E06D6D", fontSize: "calc(var(--kiosk-scale) * 1.22)" }} />
          <Typography sx={{ fontSize: "calc(var(--kiosk-scale) * 0.9)", color: "#222", fontWeight: 500 }}>
            3 Events failed to import <strong>(Check)</strong>
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};


export const LiveStatusCard = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "calc(var(--kiosk-scale) * 0.675)",
        p: "calc(var(--kiosk-scale) * 1.125)",
        borderRadius: "calc(var(--kiosk-scale) * 1.125)",
        background: "#FFFFFF",
        boxShadow: "0px calc(var(--kiosk-scale) * 0.36) calc(var(--kiosk-scale) * 1.8) rgba(0, 0, 0, 0.08)", // Decreased by 10%
        width: "calc(var(--kiosk-scale) * 19.5)",
        animation: "floating 5s ease-in-out infinite",

        "@keyframes floating": {
          "0%": {
            transform: "translateY(0px)",
          },
          "50%": {
            transform: "translateY(-8px)",
          },
          "100%": {
            transform: "translateY(0px)",
          },
        },
      }}
    >
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
        <Box>
          <Typography sx={{ fontWeight: 600, color: "#111", fontSize: "calc(var(--kiosk-scale) * 0.92)", lineHeight: 1.1, textAlign: "start" }}>
            Main City Mapper Kiosk
          </Typography>
          <Typography sx={{ color: "#777", fontSize: "calc(var(--kiosk-scale) * 0.5)", textAlign: "start" }}>
            086b5487-35fb-4796-899b-387f4353be0e
          </Typography>
        </Box>
        <Box
          sx={{
            background: "#1A3E39",
            color: "#FFFFFF",
            px: "calc(var(--kiosk-scale) * 0.9)",
            py: "calc(var(--kiosk-scale) * 0.43)",
            borderRadius: "calc(var(--kiosk-scale) * 0.6)",
          }}
        >
          <Typography sx={{ fontSize: "calc(var(--kiosk-scale) * 0.92)", fontWeight: 700, lineHeight: 1 }}>
            LIVE
          </Typography>
        </Box>
      </Box>

      <Box sx={{ display: "flex", flexDirection: "column", gap: "calc(var(--kiosk-scale) * 0.27)" }}>
        {["Google Map API is up", "All datapoints are Imported"].map((text) => (
          <Box key={text} sx={{ display: "flex", alignItems: "center", gap: "calc(var(--kiosk-scale) * 0.36)" }}>
            <CheckIcon sx={{ color: "#52A97F", fontSize: "calc(var(--kiosk-scale) * 1.22)" }} />
            <Typography sx={{ fontSize: "calc(var(--kiosk-scale) * 0.9)", color: "#222", fontWeight: 500 }}>
              {text}
            </Typography>
          </Box>
        ))}
      </Box>

      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "calc(var(--kiosk-scale) * 0.18)", pt: "calc(var(--kiosk-scale) * 0.225)" }}>
        <Typography sx={{ fontSize: "calc(var(--kiosk-scale) * 0.82)", color: "#555", fontWeight: 500 }}>
          Expand
        </Typography>
        <ArrowDownwardIcon sx={{ fontSize: "calc(var(--kiosk-scale) * 0.865)", color: "#555" }} />
      </Box>
    </Box>
  );
};


function StatusDashboardLayout() {
  return (
    <Box
      sx={{
        position: "relative",
        width: "103%",
        height: "100%",
        aspectRatio: "1 / 1",
        margin: "0 auto",
        boxSizing: "border-box",
        overflow: "hidden",


        "--kiosk-scale": "clamp(1.8vmin, 1.8vmin, 1.8vmin)",
        zIndex: 111,
        opacity: 0.85,

      }}
    >

      <Box sx={{ position: "absolute", top: "6%", left: "6%" }}>
        <AiRejectedCard />
      </Box>


      <Box sx={{ position: "absolute", top: "50%", right: "1%", transform: "translateY(-50%)" }}>
        <SyncDoneCard />
      </Box>


      <Box sx={{ position: "absolute", bottom: "6%", left: "10%" }}>
        <LiveStatusCard />
      </Box>
    </Box>
  );
}



export function FluidLabel({text="One console to manage all your Elhi Products"}) {
  const containerRef = useRef(null);
  const [fontSize, setFontSize] = useState("1rem");

  useEffect(() => {
    if (!containerRef.current) return;

    const observer = new ResizeObserver(([entry]) => {
      const width = entry.contentRect.width;
      // Text should fill ~90% of width.
      // Calibrate: character count × avg char ratio ≈ 0.52 of font size

      const charCount = text.length; // 46 chars
      // fontSize = (width * 0.90) / (charCount * 0.52)
      const computed = (width * 0.95) / (charCount * 0.55);
      // Clamp between a min and max so it never gets absurd
      const clamped = Math.min(Math.max(computed, 10), 48);
      setFontSize(`${clamped.toFixed(2)}px`);
    });

    observer.observe(containerRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <Typography
      ref={containerRef}
      sx={{
        color: "rgb(25,67,62)",
        textAlign: "start",
        fontSize,
        marginLeft: { xs: 0, md: "0.2vw" },
        width: "100%",
        whiteSpace: "nowrap",
        display: "block",
      }}
    >
      {text}
    </Typography>
  );
}

export default Login;
